// import React from 'react';
// import ReactDOM from 'react-dom';
// import './index.css';
// import App from './App';
// import * as serviceWorker from './serviceWorker';
// import { initialState } from './contexto/initialState';
// import { StateProvider } from './contexto/store';
// import { mainReducer } from './contexto/reducers';

// ReactDOM.render(
//   <StateProvider initialState={initialState} reducer={mainReducer}>
//     <App />
//   </StateProvider>,

//   document.getElementById('root')
// );

// // If you want your app to work offline and load faster, you can change
// // unregister() to register() below. Note this comes with some pitfalls.
// // Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();

import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { initialState } from './contexto/initialState';
import { StateProvider } from './contexto/store';
import { mainReducer } from './contexto/reducers';

ReactDOM.render(
  <StateProvider initialState={initialState} reducer={mainReducer}>
    <App />
  </StateProvider>,

  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
